<template>
    <v-container fluid fill-height>
        <v-layout wrap>
            <v-flex xs12>
                <v-card>
                    <v-container>
                        <v-layout wrap class="search-container">
                            <v-flex xs12 class="text-xs-center">
                                <h3>Personnel Movements History</h3>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-text-field
                                    box
                                    v-model="search.code"
                                    label="Employee Code"
                                    clearable>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-text-field
                                    box
                                    v-model="search.firstName"
                                    label="First Name"
                                    clearable>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-text-field
                                    box
                                    v-model="search.lastName"
                                    label="Last Name"
                                    clearable>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                    box
                                    :items="getPlantsWithTeamsSortedArray"
                                    item-text="PlantName"
                                    item-value="PlantID"
                                    v-model="search.oldPlantID"
                                    label="Old Plant"
                                    hint="Old Plant"
                                    placeholder="Old Plant"
                                    clearable
                                    :disabled="loadingPlants"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                    box
                                    :items="getTeamsForPlant(search.oldPlantID)"
                                    item-text="Name"
                                    item-value="TeamID"
                                    v-model="search.oldTeamID"
                                    label="Old Team"
                                    hint="Old Team"
                                    placeholder="Old Team"
                                    clearable
                                    :disabled="!search.oldPlantID"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                    box
                                    :items="getLevelsForPlant(search.oldPlantID)"
                                    item-text="Name"
                                    item-value="RoleTypeID"
                                    v-model="search.oldLevelID"
                                    label="Old Level"
                                    hint="Old Level"
                                    placeholder="Old Level"
                                    clearable
                                    :disabled="loadingLevels || !search.oldPlantID"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                    box
                                    :items="getPlantsWithTeamsSortedArray"
                                    item-text="PlantName"
                                    item-value="PlantID"
                                    v-model="search.newPlantID"
                                    label="New Plant"
                                    hint="New Plant"
                                    placeholder="New Plant"
                                    clearable
                                    :disabled="loadingPlants"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                    box
                                    :items="getTeamsForPlant(search.newPlantID)"
                                    item-text="Name"
                                    item-value="TeamID"
                                    v-model="search.newTeamID"
                                    label="New Team"
                                    hint="New Team"
                                    placeholder="New Team"
                                    clearable
                                    :disabled="!search.newPlantID"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4>
                                <v-autocomplete
                                    box
                                    :items="getLevelsForPlant(search.newPlantID)"
                                    item-text="Name"
                                    item-value="RoleTypeID"
                                    v-model="search.newLevelID"
                                    label="New Level"
                                    hint="New Level"
                                    placeholder="New Level"
                                    clearable
                                    :disabled="loadingLevels || !search.newPlantID"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-menu
                                    ref="startPickerMenu"
                                    :close-on-content-click="false"
                                    v-model="startPickerMenu"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                    <v-text-field
                                        box
                                        slot="activator"
                                        v-model="formattedSelectedStart"
                                        label="Start Date"
                                        prepend-icon="event"
                                        hint="Start Date"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker 
                                        v-model="selectedStartString"
                                        :first-day-of-week="1"
                                        @input="startPickerMenu = false">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-menu
                                    ref="endPickerMenu"
                                    :close-on-content-click="false"
                                    v-model="endPickerMenu"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                    <v-text-field
                                        box
                                        slot="activator"
                                        v-model="formattedSelectedEnd"
                                        label="End Date"
                                        prepend-icon="event"
                                        hint="End Date"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker 
                                        v-model="selectedEndString"
                                        :first-day-of-week="1"
                                        @input="endPickerMenu = false">
                                    </v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap class="search-container">
                            <v-flex xs12 sm4 md2 offset-md3>
                                <v-btn block color="warning" :loading="loadingPersonnelHistory" @click="clearSearchParams()">Clear</v-btn>
                            </v-flex>
                            <v-flex xs12 sm4 md2>
                                <v-btn block color="accent" :loading="loadingPersonnelHistory" @click="filter()">Filter</v-btn>
                            </v-flex>
                            <v-flex xs12 sm4 md2>
                                <v-btn block color="primary" :loading="loadingHistoryExport" @click="exportHistory()">Export</v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap class="search-container">
                            <v-flex xs12>
                                <v-alert :value="loadingHistoryExportError" color="error" icon="warning" outline>{{loadingHistoryExportError}}</v-alert>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex xs12 class="text-xs-center">
                                <h3>Individual Update</h3>
                            </v-flex>
                            <v-flex xs12>
                                <v-data-table
                                    :headers="headers"
                                    :items="personnelMovementHistory"
                                    :loading="loadingPersonnelHistory"
                                    no-data-text=""
                                    :pagination.sync="pagination"
                                    :rows-per-page-items="rowsPerPageItems"
                                    :total-items="personnelMovementHistoryTotal"
                                >
                                    <template v-slot:progress>
                                        <v-progress-linear color="primary" indeterminate></v-progress-linear>
                                    </template>
                                    <template v-slot:items="props">
                                        <td>{{formatDateTime(props.item.MovementTimeUTC)}}</td>
                                        <td>{{props.item.EmployeeCode}}</td>
                                        <td>{{props.item.LastName}}, {{props.item.FirstName}}</td>
                                        <td :class="oldClass(props.item.OldPlantName, props.item.NewPlantName)">{{props.item.OldPlantName}}</td>
                                        <td :class="newClass(props.item.OldPlantName, props.item.NewPlantName)">{{props.item.NewPlantName}}</td>
                                        <td :class="oldClass(props.item.OldTeamName, props.item.NewTeamName)">{{props.item.OldTeamName}}</td>
                                        <td :class="newClass(props.item.OldTeamName, props.item.NewTeamName)">{{props.item.NewTeamName}}</td>
                                        <td :class="oldClass(props.item.OldRoleName, props.item.NewRoleName)">{{props.item.OldRoleName}}</td>
                                        <td :class="newClass(props.item.OldRoleName, props.item.NewRoleName)">{{props.item.NewRoleName}}</td>
                                    </template>
                                    <template v-slot:no-data v-if="!loadingPersonnelHistory">
                                        <v-alert :value="true" color="error" icon="warning" outline>No available personnel movements found</v-alert>
                                    </template>
                                </v-data-table> 
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';
import UtilService from '@/services/utilService.js';
import moment from "moment";

export default {
    props: [],
    data() {
        return {
            search: {
                code: null,
                firstName: null,
                lastName: null,
                oldPlantID: null,
                oldTeamID: null,
                oldLevelID: null,
                newPlantID: null,
                newTeamID: null,
                newLevelID: null,
                start: null,
                end: null
            },
            pagination: {
                page: 1,
                rowsPerPage: 25,
                descending: true,
                sortBy: "MovementTimeUTC"
            },
            rowsPerPageItems: [10, 25, 50, 100, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
            startPickerMenu: false,
            endPickerMenu: false,
            headers: [
                {
                    text: "Time",
                    value: "MovementTimeUTC"
                },
                {
                    text: "Employee Code",
                    value: "EmployeeCode",
                },
                {
                    text: "Name",
                    value: "Name",
                },
                {
                    text: "Old Plant",
                    value: "OldPlantName",
                },
                {
                    text: "New Plant",
                    value: "NewPlantName"
                },
                {
                    text: "Old Team",
                    value: "OldTeamName",
                },
                {
                    text: "New Team",
                    value: "NewTeamName"
                },
                {
                    text: "Old Level",
                    value: "OldLevelName"
                },
                {
                    text: "New Level",
                    value: "NewLevelName"
                }
            ]
        }
    },
    components: {
    },
    created() {
        // make sure we are using the default values, mainly for the selected dates
        this.clearSearchParams();

        this.loadInitialData();
    },
    computed: {
        ...mapState("PersonnelMovementsStore", {
            loadingPlants: state => state.loadingPlants,
            loadingLevels: state => state.loadingLevels,
            levels: state => state.levels,
            personnelMovementHistory: state => state.personnelMovementHistory,
            personnelMovementHistoryTotal: state => state.personnelMovementHistoryTotal,
            loadingHistoryExport: state => state.loadingHistoryExport,
            personnelMovementHistoryExport: state => state.personnelMovementHistoryExport,
            loadingHistoryExportError: state => state.loadingHistoryExportError
        }),
        ...mapGetters({
            getTeamsForPlant: "PersonnelMovementsStore/getTeamsForPlant",
            getLevelsForPlant: "PersonnelMovementsStore/getLevelsForPlant",
            getPlantsWithTeamsSortedArray: "PersonnelMovementsStore/getPlantsWithTeamsSortedArray",
            loadingPersonnelHistory: "PersonnelMovementsStore/loadingPersonnelHistory"
        }),
        searchOldPlantID() {
            return this.search.oldPlantID;
        },
        searchNewPlantID() {
            return this.search.newPlantID;
        },
        formattedSelectedStart() {
            return UtilService.formatDateDMY(this.search.start);
        },
        formattedSelectedEnd() {
            return UtilService.formatDateDMY(this.search.end);
        },
        selectedStartString: {
            get() {
                return UtilService.formatDateYMD(this.search.start);
            },
            set(v) {
                this.search.start = moment(UtilService.parseDateYMD(v));
            }
        },
        selectedEndString: {
            get() {
                return UtilService.formatDateYMD(this.search.end);
            },
            set(v) {
                this.search.end = moment(UtilService.parseDateYMD(v));
            }
        },
    },
    methods: {
        clearSearchParams() {
            this.search.code = null;
            this.search.firstName = null;
            this.search.lastName = null;
            this.search.oldPlantID = null;
            this.search.oldTeamID = null;
            this.search.oldLevelID = null;
            this.search.newPlantID = null;
            this.search.newTeamID = null;
            this.search.newLevelID = null;
            this.search.start = moment().add(-7, "days");
            this.search.end = moment();
        },
        loadInitialData() {
            this.$store.dispatch("PersonnelMovementsStore/getPlants");
            this.$store.dispatch("PersonnelMovementsStore/getLevels");
            
            this.filter();
        },
        filter() {
            let params = {...this.search, ...this.pagination};

            // need to format the dates better for SQL Server
            params.start = params.start.clone().startOf("day").utc().toISOString(true);
            params.end = params.end.clone().endOf("day").utc().toISOString(true);

            this.$store.dispatch("PersonnelMovementsStore/getHistory", params);
        },
        async exportHistory() {
            let params = {};

            // need to format the dates better for SQL Server
            params.start = this.search.start.clone().startOf("day").utc().toISOString(true);
            params.end = this.search.end.clone().endOf("day").utc().toISOString(true);

            await this.$store.dispatch("PersonnelMovementsStore/getHistoryForExport", params);

            if (!this.loadingHistoryExportError) {
                // if there is an error it will be shown automatically

                // if there is no error, download a CSV file
                
                let url = window.URL.createObjectURL(new Blob([this.personnelMovementHistoryExport.data]));
                let link = document.createElement("a");
                link.href = url;
                let contentDisposition = this.personnelMovementHistoryExport.headers["content-disposition"];
                let fileName = 'unknown';
                if(contentDisposition){
                    let fileNameMatch = contentDisposition.match(/filename="(.+)"/);
                    if(fileNameMatch.length === 2){
                        fileName = fileNameMatch[1];
                    }
                }
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            }
        },
        formatDateTime(dateTime) {
            return `${UtilService.formatDateDMYHMS(moment.utc(dateTime).toDate())}`;
        },
        oldClass(oldValue, newValue) {
            return `old ${oldValue !== newValue ? "changed" : "not-changed"}`;
        },
        newClass(oldValue, newValue) {
            return `new ${oldValue !== newValue ? "changed" : "not-changed"}`;
        }
    },
    watch: {
        searchOldPlantID() {
            // clear team selection when plant selection changes
            this.search.oldTeamID = null;
        },
        searchNewPlantID() {
            // clear team selection when plant selection changes
            this.search.newTeamID = null;
        },
        pagination: {
            handler(/*newVal, oldVal*/) {
                /**
                 * The below code will stop a weird edge case race condition when re-sorting data in the data table
                 * beyond the first page. Vuetify might well update their implementation in future, so I was reluctant
                 * to include this in our code - not to mention it would need to be implemented on every server-side
                 * paginated data table. I've left it in for future reference.
                 */
                // console.log("changed!");

                // console.log(JSON.stringify(oldVal));
                // console.log(JSON.stringify(newVal));

                // let callAPI = true;

                // if (newVal.page && newVal.page > 1) {
                //     // if we are not on the first page
                //     if (newVal.descending !== oldVal.descending || newVal.sortBy !== oldVal.sortBy) {
                //         // at least one of descending or sortBy has been changed

                //         /**
                //          * Vuetify is bad and is going to automatically update the page to page 1, which will cause this
                //          * watcher to be called again immediately. This would mean 2 API calls, one fetching the previous
                //          * page and another fetching page 1. This is a race condition - sometimes page 1 of data will be
                //          * shown (correct) and sometimes another page of data is shown (incorrect).
                //          * 
                //          * To fix this, we are going to duplicate the Vuetify code to set the page to 1 here, to ensure
                //          * that the first of the network calls is not fetching data for the wrong page. Note that we don't
                //          * call the API, because Vuetify is going to cause a second update to call it again anyway.
                //          * 
                //          * An example use case to have a look at the issue:
                //          * 1. Sort results by a column
                //          * 2. Move to page 2 of results
                //          * 3. Change sort column or sort direction
                //          * => view the network tab in browser and have a look at the arguments that are sent
                //          */
                //         callAPI = false;

                //         this.pagination.page = 1;
                //     }
                // }

                // if (callAPI) {
                //     this.filter();
                // }

                this.filter();
            },
            deep: true
        }
    }
}
</script>

<style>
    .search-container .flex {
        padding-left: 5px;
        padding-right: 5px;
    }

    #app td.changed {
        /* any data that actually changed should be highlighted to make it easier to tell the difference between properties that changed and properties that did not */
        font-weight: bold;
    }

    #app td.not-changed {
        /* we still want to show the old and new data when it hasn't changed, but we'll make it very faint */
        color: lightgray;
    }
</style>
